import { stepsActions } from './slice'

export const {
  setStepsVisibility,
  setCurrentStep,
  goToNextStep,
  goToPreviousStep,
  goToLastStep,
  goToFirstStep,
  setNextStep,
  clearNextStepOverride
} = stepsActions

export default stepsActions
